import React from "react";
import { motion } from "framer-motion";
import styles from "../style/HeroText.module.css";
import { useNavigate } from "react-router-dom";

const lines = [
    "Complete IT -",
    "Digital Marketing Solution",
    "Under One Roof"
];

const letterAnimation = {
    hidden: { opacity: 0, rotateX: 90 },
    visible: (i) => ({
        opacity: 1,
        rotateX: 15,
        transition: {
            delay: i * 0.1,
            duration: 0.6,
            ease: "easeOut"
        }
    })
};

const HeroText = () => {

    const navigate = useNavigate()


    return (
        <motion.div
            className={styles.textBox}
            initial="hidden"
            animate="visible"
        >
            <h1 className={styles.title}>
                {lines.map((line, lineIndex) => (
                    <div key={lineIndex} className={styles.line}>
                        {line.split(" ").map((word, wordIndex) => (
                            <React.Fragment key={wordIndex}>
                                <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                                    {word.split("").map((char, i) => {
                                        const charIdx = line.split(" ").slice(0, wordIndex).join(" ").length + (wordIndex > 0 ? 1 : 0) + i;
                                        return (
                                            <motion.span
                                                key={i}
                                                custom={charIdx}
                                                variants={letterAnimation}
                                                className={
                                                    line === "Under One Roof" ? styles.highlight : styles.letter
                                                }
                                            >
                                                {char}
                                            </motion.span>
                                        );
                                    })}
                                </span>
                                {wordIndex < line.split(" ").length - 1 && " "}
                            </React.Fragment>
                        ))}
                    </div>
                ))}
            </h1>

            <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className={styles.btn}
                onClick={() => navigate('/blogs')}
            >
                Discover More <span>→</span>
            </motion.button>
        </motion.div>
    );
};

export default HeroText;
